module.exports = __webpack_public_path__ + "assets/img/scan.f63c396c.png";